export default class ImageUpload {
  constructor(welContainer) {
    this.MAX_IMAGE_COUNT = 4; // 최대 업로드 개수
    this.MAX_IMAGE_RESOLUTION = 1080; // 최대 이미지 해상도(긴쪽)
    this.MAX_IMAGE_MSG = '사진은 최대 4장까지 등록 가능합니다.';
    // andorid multi upload 최대 4개 체크 flag
    this.bAndroidMultiFlag = true;
    this.sMainDealSrl = TMON.util.gup('mainDealSrl');
    this.welContainer = welContainer;
    this.setCavasToBolbPolyfill();
  }

  init() {
    this.cacheElement();
    this.setEvent();
  }

  cacheElement() {
    this.welImageUpload = this.welContainer.find('#_reviewImageUploadForm');
    this.welUploadImageList = this.welContainer.find('#_uploadImageList');
    this.welUploadLoading = this.welContainer.find('#_uploadRLoading'); // 업로드 이미지 LI
    this.welUploadImage = this.welContainer.find('#_uploadRImage'); // 업로드 로딩 LI

    this.welAuthLayer = $('._access_pop');
    this.welCameraAuthLayer = $('#access_agree_pop_camera'); // 카메라 접근 권한 레이어
    this.welPictureAuthLayer = $('#access_agree_pop_picture'); // 사진 접근 권한 레이어
    this.welCamPicAuthLayer = $('#access_agree_pop'); // 카메라 & 사진 접근 권한 레이어
  }

  setEvent() {
    this.welImageUpload
      .find('.input_file')
      .on('click', this.onClickUploadImage);
    this.welImageUpload.find('.input_file').on('change', e => {
      // file list, file length, uploaded image length
      const aFiles = Array.from(e.currentTarget.files);
      const nFilesLen = aFiles.length;
      const nUploadedImageLen = this.welUploadImageList.find('._uploadImage')
        .length;

      // 업로드 할 이미지 + 이미 업로드 된 이미지 갯수 체크
      if (nFilesLen + nUploadedImageLen > this.MAX_IMAGE_COUNT) {
        if (TMON.sDevice === 'MI') {
          // ios의 경우 진입하는 경로에 따라 alert_orig를 쓸 수 있는 페이지가 정해져 있음.
          // 경로1: 마이티몬 -> 최근 구매내역 -> 리뷰쓰기 (사용불가)
          // 경로2: 마이티몬 -> 최근 구매내역 -> 전체 구매내역 -> 리뷰쓰기 (사용가능)
          // 추가로 특정 페이지에서만 작동하는 이슈로 alert_orig에서 콜앱으로 수정
          TMON.app.callApp('webview', 'showAlert', this.MAX_IMAGE_MSG, '확인');
          // alert_orig(this.MAX_IMAGE_MSG);
        } else {
          alert(this.MAX_IMAGE_MSG);
        }
        return;
      }
      aFiles.forEach(file => this.uploadImage(file));
    });
    this.welAuthLayer.on('click', 'a', () => {
      this.welAuthLayer.hide();
      return false;
    });
  }

  showIosPhotoAuth() {
    if (TMON.bMobile === false) {
      return;
    }

    const aIOSInfo = TMON.util.getIOSVersion();
    if (!aIOSInfo || !this.welAuthLayer.length) {
      return;
    }

    window.cbRequestPhotoAuth = res => {
      const htAuthority = JSON.parse(res);

      if (aIOSInfo[0] > 10 && !htAuthority.camera) {
        this.welCameraAuthLayer.show();
        return;
      }

      if (!htAuthority.photo && !htAuthority.camera) {
        this.welCamPicAuthLayer.show();
      } else if (!htAuthority.photo && htAuthority.camera) {
        this.welPictureAuthLayer.show();
      } else if (htAuthority.photo && !htAuthority.camera) {
        this.welCameraAuthLayer.show();
      }
    };

    TMON.app.callApp(
      'webview',
      'requestPhotoAuthorization',
      'cbRequestPhotoAuth'
    );
  }

  setMainDealSrl(sMainDealSrl) {
    this.sMainDealSrl = sMainDealSrl;
  }

  onClickUploadImage = e => {
    if (
      this.welUploadImageList.find('._uploadImage').length >=
      this.MAX_IMAGE_COUNT
    ) {
      // 이미지 최대 개수 만큼 이미 첨부한 경우
      alert(this.MAX_IMAGE_MSG);
      e.preventDefault();
      return;
    }

    if (TMON.sDevice === 'MA') {
      // 안드로이드의 경우 App에서 파일 업로드를 제어한다.
      this.onClickFileUploadAndroid();
      e.preventDefault();
    }
  };

  /**
   * Android의 경우 파일 업로드를 App에서 제어한다.
   */
  onClickFileUploadAndroid() {
    // 안드로이드 멀티 업로드 관련 최대갯수 flag
    this.bAndroidMultiFlag = true;

    TMON.app.callApp(
      'upload',
      'uploadImage',
      'window.cbUploadImageReviewFromApp'
    );
    this.showImageLoading();

    window.cbUploadImageReviewFromApp = res => {
      this.hideImageLoading();

      if (
        // 결과가 없거나
        !res ||
        // flag가 false일 경우 파일을 업로드하지 않음
        !this.bAndroidMultiFlag
      ) {
        return;
      }

      // 업로드 된 이미지 갯수 및 alert 출력 여부 체크
      let nUploadedImageLen = this.welUploadImageList.find('._uploadImage')
        .length;
      if (nUploadedImageLen >= this.MAX_IMAGE_COUNT && this.bAndroidMultiFlag) {
        alert(this.MAX_IMAGE_MSG);
        this.bAndroidMultiFlag = false;
        return;
      }

      const htData = JSON.parse(res);
      if (htData.success === 'Fail') {
        alert(htData.error.message);
        return;
      }

      // 현재 업로드 된 이미지 갯수가 4개보다 작을때에만 이미지 목록에서 로딩의 앞에 추가됨
      if (nUploadedImageLen < this.MAX_IMAGE_COUNT) {
        this.welUploadLoading.before(this.renderImage(htData.result.message));

        // 이미지를 4개 한꺼번에 업로드 시 버그 수정을 위해 setTimeout 이용
        setTimeout(() => {
          // 현재까지 업로드된 이미지의 수를 뷰에 업로드
          nUploadedImageLen = this.welUploadImageList.find('._uploadImage')
            .length;
          $('.review_write_out .cnt, .review_write_header .cnt').text(
            nUploadedImageLen
          );

          if (nUploadedImageLen > 3) {
            // 사진 추가 버튼 활성 상태 변경
            $('#_uploadRImage .input_file').attr('disabled', true);

            if (TMON.sDevice === 'PW') {
              $('#_uploadRImage').hide();
            }
          }
        }, 0);
      }
    };
  }

  uploadImage(oFile) {
    const sExt = oFile.name
      .split('.')
      .pop()
      .toLowerCase();

    // file ext check
    if (!['gif', 'png', 'jpg', 'jpeg'].includes(sExt)) {
      alert(`${sExt} 확장자는 업로드 가능한 이미지 파일이 아닙니다.`);
      this.welImageUpload.find('.input_file').val('');
      return;
    }

    // 로딩바 노출
    this.showImageLoading();

    try {
      // img upload
      this.rotateImage(oFile);
    } catch (error) {
      alert('업로드를 실패했습니다. 다시 시도해주세요.');
    }
  }

  /**
   * 이미지 회전 및 사이즈 조정
   * @param oFile
   */
  rotateImage(oFile) {
    const oReader = new FileReader();
    oReader.onload = readerEvent => {
      const oImage = new Image();
      oImage.onload = () => {
        // Resize the image
        const canvas = document.createElement('canvas');
        let nWidth = oImage.width;
        let nHeight = oImage.height;

        if (nWidth > nHeight) {
          if (nWidth > this.MAX_IMAGE_RESOLUTION) {
            nHeight *= this.MAX_IMAGE_RESOLUTION / nWidth;
            nWidth = this.MAX_IMAGE_RESOLUTION;
          }
        } else if (nHeight > this.MAX_IMAGE_RESOLUTION) {
          nWidth *= this.MAX_IMAGE_RESOLUTION / nHeight;
          nHeight = this.MAX_IMAGE_RESOLUTION;
        }
        canvas.width = nWidth;
        canvas.height = nHeight;
        canvas.getContext('2d').drawImage(oImage, 0, 0, nWidth, nHeight);

        /* global MegaPixImage */
        // 이미지 회전과 큰이미지를 프리뷰 할 경우 메모리부족이 발생하는 오류 빈도를 줄이기 위해 사용
        const mpImg = new MegaPixImage(oImage);

        this.getImageOrientation(oFile, imgOrientation => {
          // orientation 방향에 맞게 이미지 회전 시킴
          mpImg.render(canvas, {
            width: nWidth,
            height: nHeight,
            orientation: imgOrientation,
          });
          canvas.toBlob(oBlob => {
            this.proceedUploadImage(oBlob, oFile);
          }, oFile.type);
        });
        return false;
      };
      oImage.src = readerEvent.target.result;
    };
    oReader.readAsDataURL(oFile);
  }

  proceedUploadImage(oBlob, oFile) {
    const oFormData = new FormData();
    oFormData.append('Filedata', oBlob);
    oFormData.append(
      'file_name',
      `${new Date().getTime()}_${oFile ? oFile.name : 'uploadedImg'}`
    );

    $.ajax({
      url: `/api/review/upload/${this.sMainDealSrl}`,
      data: oFormData,
      cache: false,
      contentType: false,
      processData: false,
      type: 'POST',
      success: res => {
        this.onSuccessImageUpload(res);
      },
      error: () => {
        this.onFailImageUpload();
      },
    });
  }

  getImageOrientation(file, callBack) {
    /* global EXIF */
    EXIF.getData(file, () => callBack(EXIF.getAllTags(file).Orientation));
  }

  onFailImageUpload() {
    alert('파일 업로드에 실패하였습니다.\n잠시 후 다시 시도해 주세요.');
    this.hideImageLoading();
    this.welImageUpload.find('.input_file').val('');
  }

  onSuccessImageUpload(res) {
    this.hideImageLoading();

    if (res.data.result !== true) {
      alert('파일 업로드에 실패하였습니다.\n잠시 후 다시 시도해 주세요.');
      return;
    }

    this.welUploadLoading.before(this.renderImage(res.data.imagePath));

    let nUploadedImageLen = 0;

    // 이미지를 4개 한꺼번에 업로드 시 버그 수정을 위해 setTimeout 이용
    setTimeout(() => {
      // 현재까지 업로드된 이미지의 수를 뷰에 업로드
      nUploadedImageLen = this.welUploadImageList.find('._uploadImage').length;
      $('.review_write_out .cnt, .review_write_header .cnt').text(
        nUploadedImageLen
      );

      if (nUploadedImageLen > 3) {
        // 사진 추가 버튼 활성 상태 변경
        $('#_uploadRImage .input_file').attr('disabled', true);

        if (TMON.sDevice === 'PW') {
          $('#_uploadRImage').hide();
        }
      }

      this.welImageUpload.find('.input_file').val('');
    }, 0);
  }

  /**
   * iOS Safari 에서 canvas.toBlob() 지원을 하지 않아 polyfill 한다.
   */
  setCavasToBolbPolyfill() {
    if (HTMLCanvasElement.prototype.toBlob) {
      return;
    }

    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value(callback, imgType, quality) {
        // eslint-disable-line object-shorthand
        const url = this.toDataURL(imgType, quality);
        const m = /^data:(.*?);base64,(.*)$/.exec(url);
        const type = m[1];
        const b64 = m[2];
        setTimeout(() => {
          // eslint-disable-line prefer-arrow-callback
          callback(
            new Blob(
              [
                new Uint8Array(
                  global
                    .atob(b64)
                    .split('')
                    .map(c => c.charCodeAt(0))
                ),
              ],
              { type }
            )
          );
        }, 0);
      },
      writable: true,
      enumerable: true,
      configurable: true,
    });
  }

  showImageLoading() {
    this.welUploadLoading.show();
    this.welUploadImage.hide();
  }

  hideImageLoading() {
    this.welUploadLoading.hide();
    this.welUploadImage.show();
  }

  renderImage(sUploadedImageUrl) {
    const sImgUrl = /^http/.test(sUploadedImageUrl)
      ? sUploadedImageUrl
      : `${TMON.htStaticData.sImgCdn}${sUploadedImageUrl}`;
    const sDataUrl = /^http/.test(sUploadedImageUrl)
      ? sUploadedImageUrl.substring(sUploadedImageUrl.indexOf('/cdn'))
      : sUploadedImageUrl;
    return `<li class="review_write_item _uploadImage" data-img="${sDataUrl}">
                <div class="img_file_box" style="background-image: url('${sImgUrl}')">
                    <button type="button" role="removeImage" class="img_file_del" aria-label="이미지 삭제"><svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="btn_img_del"><g><rect id="Rectangle" fill="#000000" opacity="0.800000012" x="0" y="0" width="26" height="26"></rect><path d="M17.2857143,8 L18,8.71428571 L13.714,13 L18,17.2857143 L17.2857143,18 L13,13.714 L8.71428571,18 L8,17.2857143 L12.285,13 L8,8.71428571 L8.71428571,8 L13,12.285 L17.2857143,8 Z" id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero"></path></g></g></g></svg></button>
                </div>
            </li>`;
  }
}
